module.exports = __webpack_public_path__ + "img/msg_icon.cf6fdae5.svg";